<template>
  <div id="digital-flop">
    <div  class="digital-flop-item"  v-for="item in digitalFlopData" :key="item.title">
      <div class="digital-flop-title">{{ item.title }}</div>
      <div class="digital-flop">
        <dv-digital-flop :config="item.number" style="width:100px;height:50px;"/>
          <div class="unit">{{ item.unit }}</div>
      </div>
    </div>

    <dv-decoration-10 />
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: 'DigitalFlop',
  // props: ['subData'],
  computed: {...mapGetters(['titleList'])},
  data () {
    return {
      digitalFlopData: [],
      // tCaseCnt:0,
    }
  },
  methods: {
    createData () {
      const { randomExtend } = this;
      this.digitalFlopData = [
        {
          title: '总工单数',
          number: {
            number: [this.titleList[0].tCaseCnt],
            content: '{nt}',
            textAlign: 'right',
            style: {
              fill: '#f46827',
              fontWeight: 'bold'
            }
          },
          unit: '个'
        },
        {
          title: '总呼入电话数',
          number: {
            number: [this.titleList[0].tInCallCnt],
            content: '{nt}',
            textAlign: 'right',
            style: {
              fill: '#40faee',
              fontWeight: 'bold'
            }
          },
          unit: '个'
        },
        {
          title: '总呼出电话数',
          number: {
            number: [this.titleList[0].tOutCallCnt],
            content: '{nt}',
            textAlign: 'right',
            style: {
              fill: '#4d99fc',
              fontWeight: 'bold'
            }
          },
          unit: '个'
        },
        {
          title: '总邮件数',
          number: {
            number: [this.titleList[0].tMailCnt],
            content: '{nt}',
            textAlign: 'right',
            style: {
              fill: '#f46827',
              fontWeight: 'bold'
            }
          },
          unit: '封'
        },
        {
          title: '总微信数',
          number: {
            number: [this.titleList[0].tWxCnt],
            content: '{nt}',
            textAlign: 'right',
            style: {
              fill: '#f46827',
              fontWeight: 'bold'
            }
          },
          unit: '件'
        },
        {
          title: '当月工单数',
          number: {
            number: [this.titleList[0].mCaseCnt],
            content: '{nt}',
            textAlign: 'right',
            style: {
              fill: '#40faee',
              fontWeight: 'bold'
            }
          },
          unit: '个'
        },
        // {
        //   title: '当月呼入电话数',
        //   number: {
        //     number: [this.titleList[0].mInCallCnt],
        //     content: '{nt}',
        //     textAlign: 'right',
        //     style: {
        //       fill: '#4d99fc',
        //       fontWeight: 'bold'
        //     }
        //   },
        //   unit: '个'
        // },
        // {
        //   title: '当月呼出电话数',
        //   number: {
        //     number: [this.titleList[0].mOutCallCnt],
        //     content: '{nt}',
        //     textAlign: 'right',
        //     style: {
        //       fill: '#f46827',
        //       fontWeight: 'bold'
        //     }
        //   },
        //   unit: '个'
        // }
      
      ]
    },
    // randomExtend (minNum, maxNum) {
    //   if (arguments.length === 1) {
    //     return parseInt(Math.random() * minNum + 1, 10)
    //   } else {
    //     return parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10)
    //   }
    // }
  },
  async created(){
    const { createData } = this
    await this.$store.dispatch('screen/screenSet',{}).then(Response=>{
      createData()
    });

    // if (this.subData.tCaseCnt==0){
    //   setInterval(createData, 3000)
    // }else{
      setInterval(createData, 30000)
    // }
  },

  mounted () {
    
  }
}
</script>

<style lang="less">
#digital-flop {
  position: relative;
  height: 15%;
  flex-shrink: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: rgba(6, 30, 93, 0.5);

  .dv-decoration-10 {
    position: absolute;
    width: 95%;
    left: 2.5%;
    height: 5px;
    bottom: 0px;
  }

  .digital-flop-item {
    width: 11%;
    height: 80%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-left: 3px solid rgb(6, 30, 93);
    border-right: 3px solid rgb(6, 30, 93);
  }

  .digital-flop-title {
    font-size: 20px;
    margin-bottom: 20px;
  }

  .digital-flop {
    display: flex;
  }

  .unit {
    margin-left: 10px;
    display: flex;
    align-items: flex-end;
    box-sizing: border-box;
    padding-bottom: 13px;
  }
}
</style>
